<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.81 15.23">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          id="Path_26"
          data-name="Path 26"
          class="cls-1"
          d="M15.43,5.91h-1.3a.39.39,0,0,1-.36-.25,6,6,0,0,0-.58-1.12.38.38,0,0,1,0-.43l1-1.52a.39.39,0,0,0-.09-.54h0L12.37.86a.39.39,0,0,0-.54.1L11,2.19a.38.38,0,0,1-.47.14A6.38,6.38,0,0,0,9.65,2a.38.38,0,0,1-.29-.37V.39A.39.39,0,0,0,9,0H6.85a.39.39,0,0,0-.39.39h0V1.76a.39.39,0,0,1-.27.37A6.52,6.52,0,0,0,5.1,2.6a.38.38,0,0,1-.45-.06L3.49,1.44a.38.38,0,0,0-.54,0H3L1.48,3a.39.39,0,0,0,0,.55h0L2.61,4.6a.36.36,0,0,1,.07.46,5.37,5.37,0,0,0-.29.65A.39.39,0,0,1,2,6H.39A.38.38,0,0,0,0,6.34V8.46a.38.38,0,0,0,.39.39H1.83a.38.38,0,0,1,.37.29,6,6,0,0,0,.4,1.1.39.39,0,0,1-.06.44l-1.13,1.2a.37.37,0,0,0,0,.54h0L3,13.88a.39.39,0,0,0,.55,0h0l1-1A.37.37,0,0,1,5,12.78a6.25,6.25,0,0,0,1.24.55.39.39,0,0,1,.27.37v1.15a.38.38,0,0,0,.38.38H9a.38.38,0,0,0,.38-.38v-1a.39.39,0,0,1,.3-.37,6.24,6.24,0,0,0,1.7-.73.39.39,0,0,1,.47.05l.93.89a.38.38,0,0,0,.54,0h0l1.47-1.53a.39.39,0,0,0,0-.55l-1-1a.38.38,0,0,1-.09-.44,4.85,4.85,0,0,0,.36-1,.39.39,0,0,1,.38-.3h1.05a.39.39,0,0,0,.39-.39V6.28A.37.37,0,0,0,15.43,5.91ZM8,11.15A3.61,3.61,0,0,1,4.33,7.6,3.6,3.6,0,0,1,8,4.06,3.59,3.59,0,0,1,11.63,7.6,3.6,3.6,0,0,1,8,11.15Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
